import { render, staticRenderFns } from "./ProjectSidebar.vue?vue&type=template&id=66ab7347&scoped=true&"
import script from "./ProjectSidebar.vue?vue&type=script&lang=ts&"
export * from "./ProjectSidebar.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectSidebar.vue?vue&type=style&index=0&id=66ab7347&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66ab7347",
  null
  
)

export default component.exports